import React from 'react';
import { view } from '@risingstack/react-easy-state';

export default view(({ device }) => {
    return (
        <div>Device controls</div>
    )
})